import React from 'react';

const FunctionContext = React.createContext();

export default FunctionContext;